<template>
	<div class="module_course">

		<course-header-s-r :course-id="course.uuid" :disableTOC="true" class="header_assessment_learn"></course-header-s-r>

		<div class="row page-content" :class="isTocOpen ? 'toc_activated' : ''">
			<div class="col-12 assessment-learn can_full_screen full_screen">

				<div class="header">
					<div v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></div>
					<div class="heading">{{entity.title}}</div>
					<div class="btn_container">
                        <template v-if="islocalPracticeReviewLoaded">
                            <b-button @click="done(course.uuid, entity.objectType, entity.uuid)" class="btn button-primary next"> Done </b-button>
                        </template>
                        <template v-else>
                            <b-link class="icon-home" :to="{ name: 'clearlyNextStudentDashboard'}"></b-link>
                        </template>
          			</div>
				</div>

				<div v-if="loadLaunchAssessmentWidget" class="assessment-container">
					<template v-if="((course.courseType === 'SELECTIVE_RELEASE') || (course.courseType === 'CONVERSATION_QUEST'))">
					   <quest-launch-assessment :uuid="entityUuid" :course-id="uuid" :session-id="sessionId" :can-edit="canEdit" @localPracticeReviewLoaded="showDoneButton"></quest-launch-assessment>
					</template>
					<template v-else>
					   <launch-assessment :uuid="entityUuid" :course-id="uuid" :session-id="sessionId" @localPracticeReviewLoaded="showDoneButton"></launch-assessment>
					</template>
            	</div>

			</div>
		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseHeaderSR from './CourseHeaderSR'
import TOCSR from './TOCSR'
import LaunchAssessment from '../../assessment/components/LaunchAssessment'
import QuestLaunchAssessment from '../../assessment/components/QuestLaunchAssessment'

export default {
  name: 'assessmentLearnSR',
  props: ['uuid', 'entityType', 'entityUuid', 'sessionId', 'canEdit'],
  components: {
    CourseHeaderSR,
    TOCSR,
    LaunchAssessment,
    QuestLaunchAssessment
  },
  data: () => {
    return {
      page: 1,
      parent: null,
      ancestor: null,
      loadLaunchAssessmentWidget: false,
      islocalPracticeReviewLoaded: false
    }
  },

  mounted () {
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEntityDetail',
      'startActivity'
    ]),

    loadCourse () {
      this.loadCourseDetail(this.uuid)
      const entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.loadEntityDetail(entityDetailInfo).then((res) => {
        if (res && res.type === 'ASSESSMENT') {
          this.loadLaunchAssessmentWidget = true
        }
        var i = 0
        var j = 0
        var parentAncestorId = null
        for (i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.entity.ancestor) {
            if (this.linearTopics[j].title.indexOf(':') > -1) {
              this.parent = this.linearTopics[i].title.split(':')[0]
            } else {
              this.parent = this.linearTopics[i].title
            }
            parentAncestorId = this.linearTopics[i].ancestor
            break
          }
        }

        if (parentAncestorId != null) {
          for (j = 0; j < this.linearTopics.length; j++) {
            if (this.linearTopics[j].uuid === parentAncestorId) {
              if (this.linearTopics[j].title.indexOf(':') > -1) {
                this.ancestor = this.linearTopics[j].title.split(':')[0]
              } else {
                this.ancestor = this.linearTopics[j].title
              }
              break
            }
          }
        }
      })
      var startActivity = {
        'userId': localStorage.getItem('userid'),
        'entityUuid': this.entityUuid
      }
      this.startActivity(startActivity)
      $('.can_full_screen').addClass('full_screen')
    },

    showDoneButton (value) {
      this.islocalPracticeReviewLoaded = value
    },

    done (uuid, entityType, entityUuid) {
      this.$router.push({ name: 'entityDetailSR', params: { uuid: uuid, entityType: entityType, entityUuid: entityUuid } })
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'entity': state => state.course.entity,
			'isTocOpen': state => state.course.isTocOpen,
      'linearTopics': state => state.course.linearTopics
    })
  },

  watch: {
    entityUuid (newId) {
      if (newId) {
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>
    .header {
        background: #f7e5a8;
        margin-bottom: 30px;
        float: left;
        width: 100%;
        padding-left: 20px;
        height:62px;
    }
    .icon-home {
        font-size: 44px;
        float: left;
        color: #157099;
    }

    .heading {
        float: left;
        font-size: 20px;
        margin-top: 17px;
        color: rgb(79, 79, 79);
        font-family: robotoSlab_Light;
        max-width: calc(100% - 138px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .btn_container {
        float: right;
        margin: 12px 20px;
    }

    .container {
        width: 90%;
        max-width: 90%;
        margin-left: 5%;
        height: 98%;
    }

    .container iframe {
        width: 90% !important;
        margin-left: 5%;
        height: 95%;
    }

    .assessment-container {
        padding-left: 5%;
        width: 95%;
    }
</style>



// WEBPACK FOOTER //
// src/app/course/components/AssessmentLearnSR.vue